export default __webpack_public_path__ + "static/media/modal-diamond@1x.8fe64152.png";